import { Http } from '../../shared';
import { settings } from '../../settings';

export class ResourceService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.b2c_api;
    }


    async getOrderTicketCreationPdf(id, template) {
        var options = {
            responseType: 'blob'
        }

        var response = await this.http.get(`${this.service_url}/res/pdf/resource/orders/${id}/pdf?template=${template}`, options);
        return response.data;
    }
    async getOrderTicketCreationHtml(id, template) {
        var options = {
            headers: {
            },
        }

        var response = await this.http.get(`${this.service_url}/resources/orders/${id}/html?template=${template}`, options);
        return response.data;
    }
}
